import { render, staticRenderFns } from "./CrearScriptModal.vue?vue&type=template&id=54b21a74&scoped=true&"
import script from "./CrearScriptModal.vue?vue&type=script&lang=ts&"
export * from "./CrearScriptModal.vue?vue&type=script&lang=ts&"
import style0 from "./CrearScriptModal.vue?vue&type=style&index=0&id=54b21a74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b21a74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('54b21a74', component.options)
    } else {
      api.reload('54b21a74', component.options)
    }
    module.hot.accept("./CrearScriptModal.vue?vue&type=template&id=54b21a74&scoped=true&", function () {
      api.rerender('54b21a74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ContratoProveedor/CrearScriptModal.vue"
export default component.exports